import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useStore } from '@hooks/useStore';
import { useMinimumLoadingDuration } from '@hooks/useMinimumLoadingDuration';
import { AppShellSkeleton } from '@/components/common/skeletons';
import { buildLoginPathWithRedirect } from '@utils/oauthPostLoginRedirect';

type AuthSessionGateProps = {
  children: ReactNode;
};

/**
 * Waits for session restore when a token exists, redirects unauthenticated users to login.
 */
export function AuthSessionGate({ children }: AuthSessionGateProps) {
  const { authStore } = useStore();
  const { token, isAuthed } = authStore;
  const location = useLocation();

  const isRestoringSession = Boolean(token && !isAuthed);
  const showSkeleton = useMinimumLoadingDuration(isRestoringSession);

  if (showSkeleton) {
    return <AppShellSkeleton />;
  }

  if (!isAuthed) {
    const returnPath = `${location.pathname}${location.search}`;
    return <Navigate to={buildLoginPathWithRedirect(returnPath)} replace />;
  }

  return <>{children}</>;
}
